<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-btn color="error" dark slot="activator" @click="openCancelDialog">콜 취소</v-btn>
        <v-flex lg12>
          <v-card>
            <v-toolbar dark color="primary" flat dense cad>
              <v-btn icon @click="$router.go(-1)">
                <v-icon>keyboard_arrow_left</v-icon>
              </v-btn>
              <v-toolbar-title class="subheading">운행 정보</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-list three-line subheader>
              <v-data-table
                      :headers="complex.headers1"
                      :items="complex.items"
                      hide-actions
                      class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center">{{ changeRunningStateText(props.item.currentDriverStatus) }}</td>
                  <td class="text-sm-center">
                    <template v-if="props.item.currentDriverLocation">
                      <a :href="'https://www.google.com/maps/place/' + props.item.currentDriverLocation.y + ',' + props.item.currentDriverLocation.x" target="_blank">
                        {{ props.item.currentDriverLocation.y + ', ' + props.item.currentDriverLocation.x }}
                      </a>
                    </template>
                  </td>
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[0].userId }} -> {{ props.item.matchedRoutes.getOnOffUserSeq[1].userId }}</td>
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[2].userId }} -> {{ props.item.matchedRoutes.getOnOffUserSeq[3].userId }}</td>
                </template>
              </v-data-table>
            </v-list>
            <v-divider></v-divider>
            <v-list three-line subheader>
              <v-data-table
                      :headers="complex.headers2"
                      :items="complex.items"
                      hide-actions
                      class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center">{{props.item.driverUsage.callAcceptTimestamp}}</td>
                  <td class="text-sm-center">{{props.item.driverUsage.startTimestamp}}</td>
                  <td class="text-sm-center">{{props.item.driverUsage.secondBoardedTimestamp}}</td>
                  <td class="text-sm-center">{{props.item.driverUsage.firstDestTimestamp}}</td>
                </template>
              </v-data-table>
            </v-list>

            <v-toolbar dark color="primary" flat dense cad>
              <v-toolbar-title class="subheading">기사 정보</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-list three-line subheader>
              <v-data-table
                      :headers="complex.driverHeader"
                      :items="complex.items"
                      hide-actions
                      class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center">{{ props.item.driverUsage.id }}</td>
                  <td class="text-sm-center">{{ props.item.driverUsage.driverId }}</td>
                  <td class="text-sm-center">{{ props.item.driverUsage.driver.personalInfo.name }}</td>
                  <td class="text-sm-center">{{ props.item.driverUsage.driver.phoneNumber }}</td>
                  <td class="text-sm-center">{{ props.item.driverUsage.carNum }}</td>
                  <td class="text-sm-center">{{ props.item.driverUsage.carModelName }}</td>
                </template>
              </v-data-table>
            </v-list>

            <v-toolbar dark color="primary" flat dense cad>
              <v-toolbar-title class="subheading">승객1 정보</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-list three-line subheader>
              <v-data-table
                      :headers="complex.passengerHeader"
                      :items="complex.items"
                      hide-actions
                      class="elevation-1"
              >
                <template slot="items" slot-scope="props" v-if="props.item.matchedRoutes">
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[0].userId }}</td>
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[0].phoneNumber }}</td>
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[0].gender }}</td>
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[0].seat }}</td>
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[0].startLocationName }}</td>
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[0].endLocationName }}</td>
                </template>
              </v-data-table>
            </v-list>

            <v-toolbar dark color="primary" flat dense cad>
              <v-toolbar-title class="subheading">승객2 정보</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-list three-line subheader>
              <v-data-table
                      :headers="complex.passengerHeader"
                      :items="complex.items"
                      hide-actions
                      class="elevation-1"
              >
                <template slot="items" slot-scope="props" v-if="props.item.matchedRoutes">
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[1].userId }}</td>
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[1].phoneNumber }}</td>
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[1].gender }}</td>
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[1].seat }}</td>
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[1].startLocationName }}</td>
                  <td class="text-sm-center">{{ props.item.matchedRoutes.getOnOffUserSeq[1].endLocationName }}</td>
                </template>
              </v-data-table>
            </v-list>
          </v-card>
        </v-flex>

        <v-dialog v-model="cancelDialog.activated" scrollable max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">콜 취소</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select
                          :items="cancelDialog.callCancelUsers"
                          label="취소 유저"
                          item-text="text"
                          item-value="state"
                          single-line
                          v-model="cancelDialog.form.userId"
                  >
                  </v-select>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs12>
                  <v-select
                          :items="cancelDialog.callCancelReason"
                          label="취소 사유"
                          item-text="text"
                          item-value="state"
                          single-line
                          v-model="cancelDialog.form.reason"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="cancelCall">콜 취소</v-btn>
              <v-btn color="blue darken-1" flat @click.native="cancelDialog.activated = false">닫기</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import CallCancelReason  from '@/api/callCancelReason';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      cancelDialog: {
        callCancelUsers: [],
        callCancelReason: CallCancelReason,
        activated: false,
        form: {
          userId: null,
          reason: null
        }
      },
      complex: {
        headers1: [
          {
            text: '상태',
            value: 'currentDriverStatus',
            align: 'center',
            sortable: false
          },
          {
            text: '위치',
            value: 'currentDriverLocation',
            align: 'center',
            sortable: false
          },
          {
            text: '승차 순서',
            value: 'currentDriverLocation',
            align: 'center',
            sortable: false
          },
          {
            text: '하차 순서',
            value: 'currentDriverLocation',
            align: 'center',
            sortable: false
          },
        ],
        headers2: [
          {
            text: '콜 수락 시간',
            value: 'callAcceptTimestamp',
            align: 'center',
            sortable: false
          },
          {
            text: '첫 번째 승객 탑승 시간',
            value: 'startTimestamp',
            align: 'center',
            sortable: false
          },
          {
            text: '두 번째 승객 탑승 시간',
            value: 'secondBoardedTimestamp',
            align: 'center',
            sortable: false
          },
          {
            text: '첫 번째 승객 하차 시간',
            value: 'firstDestTimestamp',
            align: 'center',
            sortable: false
          }
        ],
        driverHeader: [
          {
            text: '기사 운행 고유번호',
            value: 'id',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 고유번호',
            value: 'driverId',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 이름',
            value: 'driver.personalInfo.name',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 전화번호',
            value: 'driver.phoneNumber',
            align: 'center',
            sortable: false
          },
          {
            text: '택시번호',
            value: 'carNum',
            align: 'center',
            sortable: false
          },
          {
            text: '택시모델명',
            value: 'carModelName',
            align: 'center',
            sortable: false
          },
        ],
        passengerHeader: [
          {
            text: '승객 고유번호',
            value: 'awaiter.id',
            align: 'center',
            sortable: false
          },
          {
            text: '승객 전화번호',
            value: 'awaiter.phoneNumber',
            align: 'center',
            sortable: false
          },
          {
            text: '승객 성별',
            value: 'awaiter.gender',
            align: 'center',
            sortable: false
          },
          {
            text: '승객 탑승위치',
            value: 'awaiter.seat',
            align: 'center',
            sortable: false
          },
          {
            text: '승객 출발지',
            value: 'awaiter.startLocationName',
            align: 'center',
            sortable: false
          },
          {
            text: '승객 목적지',
            value: 'awaiter.endLocationName',
            align: 'center',
            sortable: false
          },
        ],
        items: []
      },
    };
  },
  watch: {
    '$route.params' () {
      this.banbanCreated();
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
    this.banbanCreated();
  },
  methods: {
    banbanCreated () {
      const parameters = {
        method: 'runningBanBanCallDetail',
        'id': this.$route.params.id
      };

      this.$store.dispatch('banbanAPI', parameters)
              .then(({ data }) => {
                console.log(data);

                this.complex.items = [data];

                top.getApp.progress.dialog = false;
              })
              .catch((error) => {
                alert('이미 운행이 종료되었거나 올바른 요청이 아닙니다.\n관리자에게 문의해 주세요.');

                this.$router.push('/call/runningBanBanCalls');
              });
    },
    changeRunningStateText(state) {
      return top.getApp.changeRunningStateText(state);
    },
    openCancelDialog () {
      this.cancelDialog.activated = true;

      this.cancelDialog.callCancelUsers.push({
        text: '승객1',
        state: this.complex.items[0].matchedRoutes.getOnOffUserSeq[0].userId
      });

      this.cancelDialog.callCancelUsers.push({
        text: '승객2',
        state: this.complex.items[0].matchedRoutes.getOnOffUserSeq[1].userId
      });
    },
    cancelCall() {
      if(!this.cancelDialog.form.userId || !this.cancelDialog.form.reason) {
        alert('취소 승객 또는 취소 사유를 선택해 주세요.');
        return;
      }

      if(!confirm('해당 콜을 정말로 취소하시겠습니까?')) return;

      const parameters = {
        method: 'cancelRunningBanBanCall',
        driverUsageId: this.$route.params.id,
        userId: this.cancelDialog.form.userId,
        reason: this.cancelDialog.form.reason
      };

      this.$store.dispatch('banbanAPI', parameters)
              .then(({data}) => {
                alert('콜이 취소되었습니다.');

                this.$router.push('/call/runningBanBanCalls');
              })
              .catch((error) => {
                if (top.getApp.commonError == null) {
                  alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                }
                top.getApp.commonError = null;
                top.getApp.progress.dialog = false;
              });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/call/RunningBanBanCallDetail.vue